<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<p class="half">W<span class="smallcaps">ITH A</span></p>
<p class="halfa_j">R<span class="smallcaps1">OYAL</span> E<span class="smallcaps1">NGINEERS</span> F<span class="smallcaps1">IELD</span> C<span class="smallcaps1">OMPANY</span></p>
<p class="halfa"><span class="smallcaps">IN</span> F<span class="smallcaps">RANCE &amp; </span> I<span class="smallcaps">TALY</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?07580e36